import { Component, Input, OnInit } from '@angular/core';
import { VoucherHistoryComponent } from '../voucher-history.component';

@Component({
  selector: 'app-voucher-history-mobile',
  templateUrl: './voucher-history-mobile.component.html',
  styleUrls: ['./voucher-history-mobile.component.css']
})
export class VoucherHistoryMobileComponent implements OnInit {
  @Input() dataSource: Array<any>;
  p = 1;
  
  constructor(public voucherHistoryComponent: VoucherHistoryComponent) { }

  ngOnInit() {
  }

}
